import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePayrollSettings } from './updatePayrollSettings';
import { PayrollSettingsPayload } from './types';

import { QUERY_KEY_SETTINGS_PAYROLL } from '@/lib/api/constants';

export function useMutationPayrollSettings(companyId: string) {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async (payload: PayrollSettingsPayload) => {
            // if (COMPANY_API_SETTINGS_MOCKED) {
            //     return true
            // }
            const { data } = await updatePayrollSettings({ companyId, payload })
            return data;
        },

        onError: (error) => {
            // @TODO handle error properly
            // show notification to user
            // @TODO display notification
            console.error('Error useMutationPayrollSettings:', error);
        },

        onSuccess: (saved) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY_SETTINGS_PAYROLL, companyId] });
        },
    });
}
